<template>
  <div class="footer-content is-size-5">
    <span
      v-if="getTenantConfig('showFooterText')"
    >
      &copy; {{ new Date().getFullYear() }} Web.com Group, Inc. All Rights Reserved.&nbsp;
    </span>
    <span v-else>
      &nbsp;&nbsp;
    </span>
    <span
      v-show="phoneHelp || emailHelp"
      class="is-pulled-right has-text-weight-bold"
    >
      {{ emailHelp }}
      <span v-if="phoneHelp && emailHelp">|</span>
      {{ phoneHelp }}
    </span>
  </div>
</template>
<script>
import tenantConfigMixin from '@/mixins/tenant-config'

export default {
  name: 'Footer',
  mixins: [
    tenantConfigMixin
  ],
  computed: {
    phoneHelp () {
      if (this.$store.state.useLocalStyle) {
        return this.$t('phone_number.help')
      }
      return this.$store.getters.brandConfigValue('phone_number', 'help')
    },
    emailHelp () {
      if (this.$store.state.useLocalStyle) {
        return this.$t('email.help')
      }
      return this.$store.getters.brandConfigValue('email', 'help')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/_variables.scss';
  .footer-content {
    padding: 0 20px;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-between;
    min-width: 100%;
    color: var(--footer-text-color);
  }

@media only screen and (max-width: $break-small) {
  .footer-content {
    padding: 5px 20px;
    flex-direction: column;
    justify-content: space-around;
  }
}

</style>
